export const MODIFY_SPOC_INFO = "MODIFY_SPOC_INFO";
export const MODIFY_SPOC_TOTAL = "MODIFY_SPOC_TOTAL";
export const CLEAR_DISBURSE = "CLEAR_DISBURSE";

export const modifySpoc = (data) => {
  return {
    type: MODIFY_SPOC_INFO,
    data,
  };
};

export const modifySpocTotal = (data) => {
  return {
    type: MODIFY_SPOC_TOTAL,
    data,
  };
};

export const  clearDisburse= () => {
  return {
    type: CLEAR_DISBURSE,
    
  };
};
